import { NgModule } from '@angular/core';
import { PreloadAllModules, provideRouter, RouterModule, Routes, withPreloading, withViewTransitions } from '@angular/router';
import { HomeComponent } from './landingpage/home/home.component';
import { DashboardComponent } from './dashboard/protected/dashboard.component';
import { PublicDashboardComponent } from './dashboard/public/dashboard.component';
import { WidgetWindowComponent } from './dashboard/protected/widget-window/widget-window.component';
import { authGuard } from './guards/auth.guard';
import { publicViewAuthGuard } from './guards/public-view-auth.guard';
import { AuthCallbackComponent } from './landingpage/auth-callback/auth-callback.component';
import { LogoutComponent } from './landingpage/logout/logout.component';
import { ComponentOverview } from '../dev/dev-tools';
import { environment } from '../environments/environment';

function getRoutes() {
  let routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: HomeComponent },
    { path: 'auth/logout', component: LogoutComponent, pathMatch: 'full' },
    { path: 'addboard/auth/oidc/callback', component: AuthCallbackComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard], pathMatch: 'full' },
    { path: 'dashboard/widget/:widgetId', component: WidgetWindowComponent, canActivate: [authGuard], pathMatch: 'full' },
    { path: 'dashboard/public/:uuid', component: PublicDashboardComponent, canActivate: [publicViewAuthGuard], pathMatch: 'full' },
    { path: '**', redirectTo: 'login' }  // otherwise redirect to home
  ];
  if (!environment.production) {
    routes.splice(2, 0, { path: 'component-overview', component: ComponentOverview });
  }
  return routes;
}

const routes: Routes = getRoutes();

@NgModule({
  imports: [RouterModule],
  exports: [RouterModule],
  providers: [
    // skipInitialTransition keeps cold loads (and the Keycloak return) instant; only in-app
    // navigations animate. It is only reachable via withViewTransitions, hence provideRouter.
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withViewTransitions({ skipInitialTransition: true }),
    ),
  ],
})
export class AppRoutingModule { }